export const SUBSCRIPTIONS_API = '/api/dashboard/customer/payment/subscriptions'
